const finished_questionnaires = {
  'finished_questionnaires_title': "لقد انتهيت من الإجابة على جميع الاستبيانات الحالية",
  'finished_questionnaires_button': "الصفحة الرئيسية",
  'finished_questionnaire_title': "لقد وصلت إلى نهاية الاستبيان",
}

export default finished_questionnaires;
